import React from "react";
import { ESTADO } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

// Fix P (2026-10-13): estados nuevos de la carga (sin asignar, asignada, en ruta, terminada) y tres avisos que se pueden filtrar.
const ORDEN = ["sin_asignar", "asignada", "en_ruta", "terminada"];
const LABEL = { get sin_asignar() { return t("Sin asignar"); }, get asignada() { return t("Asignadas"); }, get en_ruta() { return t("En ruta"); }, get terminada() { return t("Terminadas"); } };
const EXTRAS = [
  ["con_problema", "Con problema", "text-danger"],
  ["por_reasignar", "Por reasignar", "text-ink"],
  ["docs_pendientes", "Documents pending", "text-brand"],
];

export function EstadoDelDia({ titulo = t("Estado del día"), contadores, estadoActivo, onEstado, actualizado, extraActivo = "", onExtra }) {
  const total = ORDEN.reduce((a, k) => a + (contadores[k] || 0), 0);
  return (
    <section className="bg-surface border border-line rounded-xl p-4 lg:p-5" data-testid="estado-del-dia">
      <div className="flex items-center justify-between mb-3">
        <h2 className="eyebrow">{titulo}</h2>
        {actualizado && <span className="text-[12.5px] text-ink-3" data-testid="actualizado-hace">{actualizado}</span>}
      </div>
      <div className="flex h-2 rounded-full overflow-hidden bg-[#ECE8E0] gap-[2px]" aria-hidden="true">
        {total > 0 && ORDEN.filter((k) => contadores[k] > 0).map((k) => (
          <span key={k} style={{ width: `${(contadores[k] / total) * 100}%`, background: ESTADO[k].color }} />
        ))}
      </div>
      <div className="mt-4 flex flex-col lg:flex-row lg:items-stretch gap-4">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-1 flex-1">
          {ORDEN.map((k) => (
            <button
              key={k}
              data-testid={`leyenda-${k}`}
              onClick={() => onEstado(estadoActivo === k ? "todos" : k)}
              aria-pressed={estadoActivo === k}
              className={cn("text-left rounded-lg px-2.5 py-2 border transition-colors duration-150", estadoActivo === k ? "bg-surface-2 border-ink" : "border-transparent hover:bg-surface-2")}
            >
              <span data-testid={`contador-${k}`} className="block font-display font-semibold text-[26px] leading-none tabular text-ink">{contadores[k] || 0}</span>
              <span className="mt-1.5 flex items-center gap-1.5 text-[12.5px] text-ink-2">
                <span className="h-[7px] w-[7px] rounded-full shrink-0" style={{ background: ESTADO[k].color }} />{LABEL[k]}
              </span>
            </button>
          ))}
        </div>
        <div className="flex flex-wrap lg:border-l lg:border-line lg:pl-5 gap-x-4 gap-y-2 items-center">
          {EXTRAS.map(([k, label, cls]) => (
            <button
              key={k}
              type="button"
              data-testid={`leyenda-extra-${k}`}
              onClick={() => onExtra && onExtra(extraActivo === k ? "" : k)}
              aria-pressed={extraActivo === k}
              className={cn("text-left rounded-lg px-2.5 py-2 border transition-colors duration-150", extraActivo === k ? "bg-surface-2 border-ink" : "border-transparent hover:bg-surface-2")}
            >
              <span data-testid={`contador-${k}`} className={cn("block font-display font-semibold text-[26px] leading-none tabular", cls)}>{contadores[k] || 0}</span>
              <span className={cn("mt-1.5 block text-[12.5px] font-semibold", cls)}>{t(label)}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
